import { App } from "../../../types/app";
import { ApiProxy, ApiCallResult } from "@infoland/api-proxy";
import snackBarService from "../../../services/snackBarService";
// state type
export interface AppState {
    apps: App[];
}
export function initialize(): AppState {
    return {
        apps: null
    };
}
// initial state
const state: AppState = initialize();
// getters for this store
const getters = {
    apps(state: AppState): App[] {
        return state.apps;
    }
};
// mutations for this store
const mutations = {
    _getApps(state: AppState, apps: App[]): void {
        // undefined should become null
        if (!apps) {
            apps = null;
        }

        state.apps = apps;
    }
};
// actions for this store
const actions = {
    async loadApps({ commit }): Promise<App[]> {
        const path = `apps`;
        const response: ApiCallResult<App[]> = await ApiProxy.getRequest(snackBarService.setMessage, path);
        commit("_getApps", response.result);
        return response.result;
    }
};

// export the namespace
export const namespace = "apps";
// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
